export default "__VITE_ASSET__t4U1kfTN__"